import { render } from "./TeaserBlock.vue?vue&type=template&id=1ed06772"
import script from "./TeaserBlock.vue?vue&type=script&lang=js"
export * from "./TeaserBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__